import { Injectable } from '@angular/core';
import { Router, Resolve, RedirectCommand } from '@angular/router';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PerkService } from '../perk/perk.service';
import { EligiblePetsWrapper } from 'src/app/interfaces/pet';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PetplanEligiblePetsResolverService implements Resolve<EligiblePetsWrapper | RedirectCommand> {

  constructor(
    private perkService: PerkService,
    private router: Router,
  ) {}

  resolve(): Observable<EligiblePetsWrapper | RedirectCommand> {
    return this.perkService.getPetplanEligiblePets(environment.perkShortCode).pipe(
      map(pets => {
        if (!pets || !pets.eligiblePets || pets.eligiblePets.length === 0) {
          const urlTree = this.router.parseUrl('/dashboard?followUs=open');
          return new RedirectCommand(urlTree);
        }
        return pets;
      })
    );
  }
}
